<template>
  <el-icon v-if="iconComponent" v-bind="bindAttrs">
    <component :is="iconComponent" />
  </el-icon>
  <i v-else :class="[icon, bindAttrs.class]" :style="bindAttrs.style" v-bind="restAttrs" />
</template>

<script>
import { resolveLegacyIcon } from '@/icons'

export default {
  name: 'AppIcon',
  inheritAttrs: false,
  props: {
    /** el-icon-* 类名，如 el-icon-search */
    icon: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconComponent() {
      const resolved = resolveLegacyIcon(this.icon)
      if (resolved && resolved.name !== 'LegacyFontIcon') return resolved
      return null
    },
    bindAttrs() {
      const { class: cls, style, ...rest } = this.$attrs
      return { class: cls, style, ...rest }
    },
    restAttrs() {
      // class/style 已合并到 :class / :style，其余属性继续透传
      const attrs = { ...this.$attrs }
      delete attrs.class
      delete attrs.style
      return attrs
    },
  },
}
</script>
